import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

import { Button } from '../../../components/Button';

export const StyledMeetingPrepText = styled.span`
  background-clip: text;
  color: transparent;
  background-image: radial-gradient(
    circle at 100%,
    rgba(2, 199, 158, 1) 0%,
    rgba(3, 194, 162, 1) 17%,
    rgba(6, 180, 175, 1) 37%,
    rgba(11, 156, 196, 1) 59%,
    rgba(112, 162, 255, 1) 81%
  );
`;

export const StyledMeetingPrepButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  position: relative;
  background-color: ${colorsPalettes.carbon[0]};
  transition: background-color 0.2s ease-in-out;
  justify-content: center;

  &:before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border-radius: 18px;
    background: radial-gradient(
      circle at 100%,
      rgba(2, 199, 158, 1) 0%,
      rgba(3, 194, 162, 1) 17%,
      rgba(6, 180, 175, 1) 37%,
      rgba(11, 156, 196, 1) 59%,
      rgba(112, 162, 255, 1) 81%
    );
    z-index: -1;
  }

  &:hover {
    background-color: ${colorsPalettes.carbon[25]};
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${colorsPalettes.carbon[0]};
`;
